import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useAddress from "./useAddress";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, addressFields } = useAddress();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('towns').then(res => {
      setData({ data: res?.data });
    });

    axios.get('customerAddresses/' + id).then(res => {
      reset(res?.data?.address);
    });

  }, []);

  const editAddress = data => {
    axios.put('customerAddresses/' + data.id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Address has been updated successfully!', {
            icon: "success",
          });
          navigate("/customers/" + data?.user_id);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit address">
      <form className="form w-100 row" onSubmit={handleSubmit(editAddress)}>
        {addressFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}